module.exports = __webpack_public_path__ + "images/category_lp/brand/new/mainBg_5f16870f7d583c24982cc02f27d76fcd.jpg";